import { Divider, Grid } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { useStore } from "../../../../utils/useStore";
import AcxMainTextField from "../../../UI/AcxMainTextFieldGrid";
import AcxSelectMulti from "../../../UI/Select/BaseSelectComponents/AcxSelectMulti";
import { EvalReviewStore } from "../Stores/EvalReviewStore";

interface IReviewDetailsProps {
    isCoached: boolean;
}

const ReviewDetails: FunctionComponent<IReviewDetailsProps> = observer(
    (props) => {
        const store = useStore(EvalReviewStore);

        function onImproveNotesChange(
            evt: React.ChangeEvent<HTMLInputElement>,
        ) {
            const val = evt.target.value;
            store.agentCoaching?.setImprovementNotes(val);
        }

        function onDoWellChange(evt: React.ChangeEvent<HTMLInputElement>) {
            const val = evt.target.value;
            store.agentCoaching?.setDoWellNotes(val);
        }

        function onResponseNotesChange(
            evt: React.ChangeEvent<HTMLInputElement>,
        ) {
            const val = evt.target.value;
            store.agentCoaching?.setResponseNotes(val);
        }

        return (
            <Grid container item direction="column" flexWrap="nowrap">
                <Grid item padding={2}>
                    <AcxMainTextField
                        id={"eval-coaching-do-well-notes"}
                        multiLine
                        rows={1}
                        rowsMax={6}
                        labelText={"What did the agent do well?"}
                        placeholderText="Add feedback..."
                        disabled={props.isCoached}
                        onChange={onDoWellChange}
                        value={store.agentCoaching?.agentDoWellNotes ?? ""}
                        sx={(theme) => ({
                            padding: theme.spacing(2),
                        })}
                        labelSx={(theme) => ({
                            color: theme.palette.gray[600],
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "20px",
                        })}
                        textContainerSx={(theme) => ({
                            borderColor: theme.palette.gray[200],
                            ":focus-within": {
                                borderColor: theme.palette.primary.main,
                            },
                        })}
                    />
                </Grid>
                <Divider />
                <Grid item padding={2}>
                    <AcxMainTextField
                        id={"eval-coaching-improvement-notes"}
                        multiLine
                        rows={1}
                        rowsMax={6}
                        labelText={"What areas of opportunity exist?"}
                        placeholderText="Add feedback..."
                        disabled={props.isCoached}
                        onChange={onImproveNotesChange}
                        value={store.agentCoaching?.improvementNotes ?? ""}
                        sx={(theme) => ({
                            padding: theme.spacing(2),
                        })}
                        labelSx={(theme) => ({
                            color: theme.palette.gray[600],
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "20px",
                        })}
                        textContainerSx={(theme) => ({
                            borderColor: theme.palette.gray[200],
                            ":focus-within": {
                                borderColor: theme.palette.primary.main,
                            },
                        })}
                    />
                </Grid>
                <Divider />
                <Grid item padding={2}>
                    <AcxSelectMulti
                        options={store.focusAreaQuestions ?? []}
                        id={"eval-coaching-focus-areas-selector"}
                        containerHeight={"auto"}
                        valueField={"value"}
                        fullWidth
                        isDisabled={props.isCoached}
                        onChange={store.agentCoaching?.setFocusAreas}
                        defaultValue={store.agentCoaching?.focusAreaQuestions}
                        labelField={"value"}
                        inputLabel={"Focus Areas"}
                    />
                </Grid>
                {props.isCoached && (
                    <React.Fragment>
                        <Divider />
                        <Grid item padding={2}>
                            <AcxMainTextField
                                id={"agent-coaching-response-notes"}
                                multiLine
                                rows={1}
                                rowsMax={6}
                                labelText={"Agent Response"}
                                onChange={onResponseNotesChange}
                                placeholderText={"Comment NA for no response"}
                                value={store.agentCoaching?.responseNotes ?? ""}
                                sx={(theme) => ({
                                    padding: theme.spacing(2),
                                })}
                                autoFocus
                            />
                        </Grid>
                    </React.Fragment>
                )}
            </Grid>
        );
    },
);

export default ReviewDetails;
